"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsEvents = void 0;
var vanilla_lazyload_1 = __importDefault(require("vanilla-lazyload"));
var globals_1 = require("./globals");
var collectPropsFromElement_1 = require("./lib/collectPropsFromElement");
function gaItemToUaItem(gaItem) {
    var uaItem = {
        id: gaItem.item_id,
        name: gaItem.item_name,
    };
    if (gaItem.item_brand)
        uaItem.brand = gaItem.item_brand;
    if (gaItem.coupon)
        uaItem.coupon = gaItem.coupon;
    if (gaItem.item_list_name)
        uaItem.list_name = gaItem.item_list_name;
    if (gaItem.index)
        uaItem.list_position = gaItem.index;
    if (gaItem.price)
        uaItem.price = gaItem.price;
    if (gaItem.quantity)
        uaItem.quantity = gaItem.quantity;
    if (gaItem.item_variant)
        uaItem.variant = gaItem.item_variant;
    var categories = [];
    if (gaItem.item_category)
        categories.push(gaItem.item_category);
    if (gaItem.item_category2)
        categories.push(gaItem.item_category2);
    if (gaItem.item_category3)
        categories.push(gaItem.item_category3);
    if (gaItem.item_category4)
        categories.push(gaItem.item_category4);
    if (gaItem.item_category5)
        categories.push(gaItem.item_category5);
    if (categories)
        uaItem.category = categories.join("/");
    return uaItem;
}
function analyticsEvents() {
    if (!globals_1.gtag) {
        console.error("No gtag.js available");
        return;
    }
    // login
    globals_1.BX.addCustomEvent("login-success", function () { return globals_1.gtag("event", "login"); });
    // signup
    globals_1.BX.addCustomEvent("signup-success", function () { return globals_1.gtag("event", "signup"); });
    // view_item
    var viewItemScript = document.querySelector("script.analytics-view-item-event");
    if (viewItemScript) {
        var gaEvent = collectPropsFromElement_1.collectPropsFromElement(viewItemScript);
        globals_1.gtag("event", "view_item", gaEvent);
        var uaItems = gaEvent.items.map(function (gaItem) { return gaItemToUaItem(gaItem); });
        globals_1.gtag("event", "view_item", { items: uaItems });
        globals_1.dataLayer.push({ ecommerce: { detail: { products: uaItems } } });
    }
    // view_item_list
    // only send event when list is in the view
    new vanilla_lazyload_1.default({
        elements_selector: ".js-analytics-view-item-list",
        unobserve_entered: true,
        callback_enter: function (list) {
            var viewItemList = list.querySelector("script.analytics-view-item-list-event");
            if (viewItemList) {
                var gaEvent = collectPropsFromElement_1.collectPropsFromElement(viewItemList);
                globals_1.gtag("event", "view_item_list", gaEvent);
                var uaItems = gaEvent.items.map(function (gaItem) { return gaItemToUaItem(gaItem); });
                globals_1.gtag("event", "view_item_list", { items: uaItems });
                globals_1.dataLayer.push({ ecommerce: { impressions: { products: uaItems } } });
            }
        },
    });
    // add_to_cart
    globals_1.BX.addCustomEvent("LocalOnCartItemAdd", function (event) {
        var cartItem = event.data;
        var gaItem = {
            item_id: cartItem.article,
            item_name: cartItem.name,
            item_brand: cartItem.manufacturer,
            price: cartItem.price,
            currency: cartItem.currency,
            quantity: cartItem.quantity,
        };
        if (cartItem.sections[0])
            gaItem.item_category = cartItem.sections[0];
        if (cartItem.sections[1])
            gaItem.item_category2 = cartItem.sections[1];
        if (cartItem.sections[2])
            gaItem.item_category3 = cartItem.sections[2];
        if (cartItem.sections[3])
            gaItem.item_category4 = cartItem.sections[3];
        if (cartItem.sections[4])
            gaItem.item_category5 = cartItem.sections[4];
        globals_1.gtag("event", "add_to_cart", {
            value: cartItem.price,
            currency: cartItem.currency,
            items: [gaItem],
        });
        var uaItem = gaItemToUaItem(gaItem);
        globals_1.gtag("event", "add_to_cart", {
            value: cartItem.price,
            currency: cartItem.currency,
            items: [uaItem],
        });
        globals_1.dataLayer.push({
            event: "addToCart",
            ecommerce: { add: { products: [uaItem] } },
        });
    });
    // remove_from_cart
    var removeFromCartScript = document.querySelector("script.analytics-remove-from-cart-event");
    if (removeFromCartScript) {
        var gaEvent = collectPropsFromElement_1.collectPropsFromElement(removeFromCartScript);
        globals_1.gtag("event", "remove_from_cart", gaEvent);
        var uaItems = gaEvent.items.map(function (gaItem) { return gaItemToUaItem(gaItem); });
        globals_1.gtag("event", "remove_from_cart", {
            items: uaItems,
            currency: gaEvent.currency,
            value: gaEvent.value,
        });
        globals_1.dataLayer.push({
            event: "removeFromCart",
            ecommerce: { remove: { products: uaItems } },
        });
    }
    // begin_checkout
    var beginCheckoutScript = document.querySelector("script.analytics-begin-checkout-event");
    if (beginCheckoutScript) {
        var gaEvent = collectPropsFromElement_1.collectPropsFromElement(beginCheckoutScript);
        globals_1.gtag("event", "begin_checkout", gaEvent);
        var uaItems = gaEvent.items.map(function (gaItem) { return gaItemToUaItem(gaItem); });
        globals_1.gtag("event", "begin_checkout", {
            items: uaItems,
            currency: gaEvent.currency,
            value: gaEvent.value,
        });
        globals_1.dataLayer.push({
            event: "checkout",
            ecommerce: {
                checkout: {
                    products: uaItems,
                },
            },
        });
    }
    // purchase
    var purchaseScript = document.querySelector("script.analytics-purchase-event");
    if (purchaseScript) {
        var gaEvent = collectPropsFromElement_1.collectPropsFromElement(purchaseScript);
        globals_1.gtag("event", "purchase", gaEvent);
        var uaItems = gaEvent.items.map(function (gaItem) { return gaItemToUaItem(gaItem); });
        globals_1.gtag("event", "purchase", {
            items: uaItems,
            currency: gaEvent.currency,
            value: gaEvent.value,
            transaction_id: gaEvent.transaction_id,
        });
        globals_1.dataLayer.push({
            ecommerce: {
                currencyCode: gaEvent.currency,
                purchase: {
                    actionField: { id: gaEvent.transaction_id, revenue: gaEvent.value },
                    products: uaItems,
                },
            },
        });
    }
}
exports.analyticsEvents = analyticsEvents;
